import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

export interface SkeletonColumn {
  width?: string;
  type?: 'text' | 'icon-text' | 'icon' | 'badge' | 'actions';
}

@Component({
  selector: 'app-table-skeleton',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.scss'],
})
export class TableSkeletonComponent {
  @Input() rows: number = 4;
  @Input() columns: number | SkeletonColumn[] = 3;
  @Input() showHeader: boolean = true;
  @Input() showCardHeader: boolean = false;
  @Input() actionMessage: string | null = null;

  get rowsArray(): number[] {
    return Array(this.rows).fill(0);
  }

  get columnsConfig(): SkeletonColumn[] {
    if (typeof this.columns === 'number') {
      return Array(this.columns).fill({ type: 'text' });
    }
    return this.columns;
  }
}
